import React, { useState } from 'react';
import { useInput } from '../hooks/useInput';
import { HalfCircleSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import { requestNewPassword } from '../api/services/password';
import { Button } from './ui/button';
import { FieldLabel } from './ui/field-label';
import { Input } from './ui/input';

const ForgotPasswordForm = (props) => {
    const [email, bindEmail] = useInput("");
    const [errors, setErrors] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    const validateForgot = () => {
        let errors = {};
        let isValid = true;
        if (!email) {
            isValid = false;
            errors["email"] = "Please enter your Email.";
            toast.error('Please enter your email to reset password.');
        }
        setErrors(errors);
        return isValid;
    };

    const forgotPasswordHandler = (event) => {
        event.preventDefault();
        if (validateForgot()) {
            setShowLoader(true);
            requestNewPassword.request({ email }).then(res => {
                setShowLoader(false);
                toast.success(res.message);
                props.setShowForgotPasswordForm(false)
            }).catch(err => {
                setShowLoader(false);
                toast.error(err.data.message);
            })
        }
    };

    return (
        <form className="space-y-4" onSubmit={(event) => forgotPasswordHandler(event)}>
            <div>
                <FieldLabel required htmlFor="forgot-email">Email</FieldLabel>
                <Input
                    id="forgot-email"
                    className={`mt-1 ${errors.email ? 'border-danger' : ''}`}
                    type="email"
                    placeholder="Email"
                    autoComplete="email"
                    {...bindEmail}
                />
            </div>
            <Button type="submit" className="w-full" disabled={showLoader}>
                Reset Password
                {showLoader && (
                    <HalfCircleSpinner size={18} style={{ display: 'inline-block' }} />
                )}
            </Button>
            <p className="text-center text-sm text-ink-600">
                <button
                    type='button'
                    className='font-semibold text-green-600 hover:text-green-700'
                    onClick={() => {
                        props.setShowForgotPasswordForm(false)
                    }}
                >Back to Login</button>
            </p>
        </form>
    )
}

export default ForgotPasswordForm;
